import { useRef, useCallback } from 'react';

// Custom hook for infinite scroll functionality using Intersection Observer
export const useInfiniteScroll = (loading, hasMore, callback) => {
  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting && hasMore) {
          // Disconnect immediately to avoid multiple rapid triggers
          try {
            observer.current.disconnect();
          } catch (e) {
            // ignore
          }
          callback();
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, callback]
  );

  return lastElementRef;
};